import { jsonMember, jsonObject } from 'typedjson';
import { SubscriptionStatus } from '../../../shared/enums';
import { PublicSubscriptionContextOperationsResponse } from './public-subscription-context-operations.response';
import { SubscriptionNumber } from '../../../shared/types';
import { Guid } from '@web/utils';

@jsonObject
export class PublicSubscriptionCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Boolean)
  public readonly isLocked!: boolean;

  @jsonMember(String)
  public readonly number!: SubscriptionNumber;

  @jsonMember(String)
  public readonly status!: SubscriptionStatus;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(Date)
  public readonly nextPaymentDate?: Date;

  @jsonMember(PublicSubscriptionContextOperationsResponse)
  public readonly contextOperations!: PublicSubscriptionContextOperationsResponse;
}
